import { CircularProgress as MuiCircularProgress } from '@mui/material';
import { styled, SxProps, Theme } from '@classify/react-core-components/styles';

import percentService from './services/percent';

export interface Props {
  maxValue: number;
  value: number;
  sx?: SxProps<Theme>;
}

const Root = styled('div')({
  position: 'relative',
  display: 'inline-block',
  height: 20,
  width: 20,
});

const Circle = styled(MuiCircularProgress)(({ theme: { palette } }) => ({
  color: palette.divider,
  position: 'absolute',
  border: 'none',
}));

const Progress = styled(MuiCircularProgress)(({ theme: { palette } }) => ({
  color: palette.progress.learningAsset.inProgress,
  strokeLinecap: 'round',
  position: 'relative',
}));

const MIN_DISPLAYABLE_VALUE = 1;
const MAX_DISPLAYABLE_VALUE = 94;

function CircularLearningProgress({ value, maxValue, sx = {} }: Props) {
  const percent = Math.min(
    Math.max(percentService.getPercent(value, maxValue), MIN_DISPLAYABLE_VALUE),
    MAX_DISPLAYABLE_VALUE
  );

  const progressProps =
    percent === MAX_DISPLAYABLE_VALUE
      ? {
          style: { transform: 'rotate(-80deg)' },
        }
      : {};

  if (value === maxValue) {
    return null;
  }

  return (
    <Root aria-hidden sx={sx}>
      <Circle variant="determinate" value={100} size={20} thickness={6} />
      <Progress variant="determinate" value={percent} size={20} thickness={6} {...progressProps} />
    </Root>
  );
}

export default CircularLearningProgress;
